import { FaTimes, FaKey } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { startOutgoingCall, setCallActive } from "../features/call/callSlice";
import { showError } from "../utils/toast";
import {
    InitiateCall
} from "../services/api";
import { getMediaUrl, getProfileImage } from "../utils/helpers";
import { useNavigate } from "react-router-dom";

export default function PrivateCallModal({ onClose, host }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state?.auth?.user);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const OnContinueClick = async () => {

        if (user?.role === host?.role) {
            showError("host to host call is not allowed");
            return;
        }

        if (user?.walletBalance < host?.ratePerMinute) {
            showError("You have insufficient balance");
            onClose();
            navigate("/payment");
            return;
        }

        try {
            const initiateCallRes = await InitiateCall({
                receiverId: host?._id
            });

            if (initiateCallRes?.data?.status === "ringing") {
                dispatch(
                    startOutgoingCall({
                        callId: initiateCallRes?.data?.callId,
                        remote: {
                            userId: host._id,
                            name: host?.name,
                            age: host?.age,
                            profileImg: getMediaUrl(host?.ppImageURL),
                            country: host?.countryId?.name,
                            flag: host?.countryId?.flag,
                        },
                    })
                );

                dispatch(setCallActive());

                onClose();
            }
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <div
            className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50"
            onClick={handleOverlayClick}
        >

            <div
                className="relative bg-[#0e0e0e] text-white w-[90%] max-w-md rounded-3xl p-6 border border-white/10 shadow-2xl"
                onClick={(e) => e.stopPropagation()}
            >

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-white hover:text-gray-300 text-xl"
                >
                    <FaTimes />
                </button>

                {/* Header Badge */}
                <div className="flex justify-center mb-6">
                    <div className="bg-red-500 px-6 py-2 rounded-full text-lg font-semibold flex items-center gap-2 shadow-lg">
                        <FaKey className="text-yellow-400" />
                        Private Call
                    </div>
                </div>

                {/* Host Image with Glow */}
                <div className="flex justify-center mb-4">
                    <div className="relative">
                        <div className="absolute inset-0 w-[160px] h-[160px] rounded-full bg-red-500 blur-2xl opacity-40"></div>

                        <img
                            src={getProfileImage(getMediaUrl(host?.ppImageURL))}
                            alt="host"
                            className="relative w-[160px] h-[160px] rounded-full border-4 border-white object-cover z-10"
                        />
                    </div>
                </div>

                {/* Text Info */}
                {user?.role === "user" &&
                    <div className="text-center px-4 space-y-2">
                        <p className="text-lg font-medium flex items-center justify-center gap-2">
                            It Costs
                            <span className="flex items-center gap-1 text-yellow-400 font-bold">
                                <img
                                    src="./images/goldcoin.png"
                                    alt="coin"
                                    className="w-6 h-6 rounded-full object-cover"
                                />
                                {host?.ratePerMinute}
                            </span>
                            / minute
                        </p>

                        <p className="text-gray-300 text-sm">
                            Calls shorter than one minute are rounded to one minute.
                        </p>
                    </div>
                }

                {/* Coins */}
                {user?.role === "user" &&
                    <div className="mt-5">
                        <p className="bg-white/10 px-4 py-2 rounded-full w-fit mx-auto">
                            My Coins: <span className="text-yellow-400 font-bold">{user?.walletBalance.toFixed(2)}</span>
                        </p>
                    </div>
                }

                {/* Continue Button */}
                <button
                    onClick={OnContinueClick}
                    className="w-full mt-6 bg-red-500 text-white py-3 rounded-full font-semibold text-lg shadow-xl transition"
                >
                    Continue
                </button>

            </div>
        </div>
    );
}